import React from "react";
import { Box } from "@chakra-ui/react";
import { ManagerProfileEmptySectionProps } from "./ManagerProfileEmptySection.types";
import { Button } from "../../common/Button";
import { ChevronRightIcon } from "../../../icons";

export const ManagerProfileEmptySection: React.FC<
  ManagerProfileEmptySectionProps
> = ({ description, buttonLabel, isLoading, onAction, to, ...rest }) => {
  return (
    <Box
      border={"2px dashed"}
      borderColor={"brand.main"}
      borderRadius={4}
      {...rest}
    >
      <Box
        p={6}
        textStyle={"bodyRegular"}
        color={"text.black"}
        bg={"bg.white"}
        {...rest}
      >
        <Box mb={2}>{description}</Box>
        <Button
          empty
          to={to}
          color={"brand.main"}
          textStyle={"bodyRegular"}
          fontWeight={"500"}
          onClick={onAction}
          isLoading={isLoading}
        >
          {buttonLabel}
          <ChevronRightIcon mr={4} boxSize={5} />
        </Button>
      </Box>
    </Box>
  );
};
